import React from "react";
import Title from "../../../Components/SadenComponents/Titel";
import CardHozor from "../../../Components/SadenComponents/CardHozor";
import CardMorakhasi from "../../../Components/SadenComponents/CardMorakhasi";
import TrackingComponent from "../../../Components/SadenComponents/TablePeigiry";
import TaskComponent from "../../../Components/SadenComponents/TaskCard";
import HalfChart from "../../../Components/SadenComponents/Chart";
import {useNavigate} from "react-router-dom";

const DashboardTypeSaden = ({dashboardComponentData, showAdminReport}) => {

  const navigateTo = useNavigate()

  return (
    <>
      <div className={"row-go-to-page-new"}>
        {showAdminReport &&
          <button className={'go-to-page-new'}
                  onClick={() => navigateTo('/adminReport')}
          > رفتن به داشبورد مدیریتی سادن
          </button>}
        {dashboardComponentData?.marketingCRM &&
          <button onClick={() => navigateTo('/lead-manage')}
                  className={"go-to-page-new"}>داشبورد CRM
          </button>}
      </div>

      <div className="saden-dashboard">

        <div className="right-side">
          {<TaskComponent
            openTasks={dashboardComponentData.openTasks}
            pendingTasks={dashboardComponentData.pendingTasks}
          />
          }
          {<TrackingComponent
            columns={dashboardComponentData.columns}
            columnsone={dashboardComponentData.columnsone}
            trackingBoxData={dashboardComponentData.trackingBoxData}
            followMeData={dashboardComponentData.followMeData}
          />}

        </div>

        <div className="left-side">

          {<div>
            <Title title="حضور غیاب"/>
            <CardHozor data={dashboardComponentData.hozorQiab}/>
          </div>}

          {<div>
            <Title title="مرخصی"/>
            {<CardMorakhasi
              usedLeave={dashboardComponentData.morakhasi.usedLeave}
              entitledLeave={dashboardComponentData.morakhasi.entitledLeave}
              remainingLeave={dashboardComponentData.morakhasi.remainingLeave}
            />}
          </div>}

          {<div>
            <Title title="گزارشات ماهانه"/>
            {<HalfChart chartdata={dashboardComponentData.chartData}/>}
          </div>}

        </div>
      </div>
    </>
  )
    ;
};

export default DashboardTypeSaden;
